import axios from 'axios';
import { history } from '../../../History';
import config from '../../../config/api';
import { message } from 'antd';
import { togglePreloader } from '../App/AppActions';
import { resetAuthReducer } from '../Auth/AuthActions';

export const setConfig1 = (data) => ({
  type: 'SET_CONFIG_1',
  data
})

export const setConfig2 = (data) => ({
  type: 'SET_CONFIG_2',
  data
})

export const setSelectedValues = (data) => ({
  type: 'SET_SELECTED_VALUES',
  data
})

export const setHeadings = (data) => ({
  type: 'SET_HEADINGS',
  data
})

export const setSelectedHeading = (data) => ({
  type: 'SET_SELECTED_HEADING',
  data
})

export const setMappings = (data) => ({
  type: 'SET_MAPPINGS',
  data
})

export const setMappingChild = (data) => ({
  type: 'SET_MAPPING_CHILD',
  data
})

export const setMappingParent = (data) => ({
  type: 'SET_MAPPING_PARENT',
  data
})

export const setConfigList = (data) => ({
  type: 'SET_CONFIG_LIST',
  data
})

export const changeIcToUpdate = (data) => ({
  type: 'CHANGE_IC_TO_UPDATE',
  data
})

export const updateStep = (data) => ({
  type: 'UPDATE_STEP',
  data
})

export const setFilterList = (data) => ({
  type: 'SET_FILTER_LIST',
  data
})

export const setSecTabs = (data) => ({
  type: 'SET_SEC_TABS',
  data
})

export const addingConfigStatus = (data) => ({
  type: 'ADDING_CONFIG_STATUS',
  data
})

export const setFilesToPublish = (data) => ({
  type: 'SET_FILES_TO_PUBLISH',
  data
})

export const setDataToDownloadData = (data) => ({
  type: 'SET_DATA_TO_DOWNLOAD_DATA',
  data
})

export const setDataToDownloadIc = (data) => ({
  type: 'SET_DATA_TO_DOWNLOAD_IC',
  data
})

export const setDataToDownloadType = (data) => ({
  type: 'SET_DATA_TO_DOWNLOAD_TYPE',
  data
})

export const setDataToDownloadChannel = (data) => ({
  type: 'SET_DATA_TO_DOWNLOAD_CHANNEL',
  data
})

export const getConfigList = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: {
        key: token
      },
      cmd: 'ic:configList',
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setConfigList(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          history.push('/');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          message.error('You have been logged out! Please login to continue');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const getFilterList = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: { key: token },
      cmd: 'filter:list',
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setFilterList(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          history.push('/');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          message.error('You have been logged out! Please login to continue');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const getSecTabs = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: { key: token },
      cmd: 'secondaryTab:list',
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setSecTabs(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const getFilesToPublish = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: { key: token },
      cmd: 'files:toPublish',
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setFilesToPublish(response.data.reply.message.filter(file => file.type === 'datasheet')));
        }
        else if (response.data.reply.code === 204) {
          message.error(response.data.reply.message);
          dispatch(togglePreloader(false));
          dispatch(setFilesToPublish([]));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const setIcConfig = (data, from) => {
  return function (dispatch) {
    dispatch(addingConfigStatus(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const auth = { "key": token };
    data['auth'] = auth;
    if (from === 'add') {
      data['cmd'] = "ic:configAdd";
    }
    else {
      data['cmd'] = "ic:configUpdate";
    }
    data.authUser = { role, email }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          if (from === 'add') {
            message.success(response.data.reply.message);
          }
          else {
            message.success('Config Updated Successfully');
          }
          dispatch(setSelectedValues({}));
          dispatch(setMappings({}));
          dispatch(setHeadings([]));
          dispatch(updateStep(1));
          dispatch(addingConfigStatus(false));
        }
        else if (response.data.reply.code === 400) {
          message.error(response.data.reply.message);
          dispatch(setSelectedValues({}));
          dispatch(setMappings({}));
          dispatch(setHeadings([]));
          dispatch(updateStep(1));
          dispatch(addingConfigStatus(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(addingConfigStatus(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(addingConfigStatus(false));
      })
  }
}

export const setIcToUpdate = (data) => {
  return function (dispatch) {
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: {
        key: token
      },
      cmd: "ic:configGet",
      ic_code: data,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(setSelectedValues(response.data.reply.message));
          dispatch(setMappings(response.data.reply.message.mappings.cpg_map));
          dispatch(setHeadings(response.data.reply.message.heading_order));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        message.error('Something went wrong! Please try again!');
      })
  }
}

export const publishFile = (data) => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'data:publish',
      auth: { "key": token },
      fileName: data.name,
      type: data.type,
      authUser: {
        role, email
      }
    }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(togglePreloader(false));
          dispatch(getFilesToPublish());
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const downloadFile = (data) => {
  return function (dispatch) {
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'file:download',
      auth: { "key": token },
      fileName: data.name,
      authUser: {
        role, email
      }
    }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          window.open(response.data.reply.message, '_blank');
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }
}

export const getDataToDownloadList = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: {
        key: token
      },
      cmd: 'datapoints:types',
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setDataToDownloadData(response.data.reply.message));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const DownloadDataSet = (type, ic_code, calc_exc_fields) => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      auth: {
        key: token
      },
      cmd: 'download:data_points',
      type: type,
      authUser: {
        role, email
      }
    };
    if (ic_code.length) {
      form_data.ic_code = ic_code;
    }
    if (calc_exc_fields.length) {
      form_data.calc_exc_fields = calc_exc_fields;
    }
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        dispatch(setDataToDownloadIc(''));
        dispatch(setDataToDownloadType(''));
        dispatch(setDataToDownloadChannel(''));
        if (response.data.reply.code === 200) {
          message.success('Data downloaded successfully!');
          dispatch(togglePreloader(false));
          let actualData = [];
          response.data.reply.message.forEach(function (jsonObj) {
            if (!isObjectEmpty(jsonObj.data_points) && !isObjectEmpty(jsonObj.data_points.value)) {
              for (var year in jsonObj.data_points.value) {
                if (year != 'METRIC') {
                  let newYear = "y" + year;
                  jsonObj.data_points.value[newYear] = parseFloat(jsonObj.data_points.value[year]);
                  delete jsonObj.data_points.value[year];
                }
              }
            }
            if (!isObjectEmpty(jsonObj.data_points) && !isObjectEmpty(jsonObj.data_points.volume)) {
              for (var year in jsonObj.data_points.volume) {
                if (year != 'METRIC') {
                  let newYear = "y" + year;
                  jsonObj.data_points.volume[newYear] = parseFloat(jsonObj.data_points.volume[year]);
                  delete jsonObj.data_points.volume[year];
                }
              }
            }
            if (!isObjectEmpty(jsonObj.data_points) && isObjectEmpty(jsonObj.data_points.value) && isObjectEmpty(jsonObj.data_points.volume)) {
              for (var year in jsonObj.data_points) {
                if (year != 'METRIC') {
                  let newYear = "y" + year;
                  jsonObj.data_points[newYear] = parseFloat(jsonObj.data_points[year]);
                  delete jsonObj.data_points[year];
                }
              }
            }
            actualData.push(jsonObj);
          })
          flattenData(actualData, type, ic_code, calc_exc_fields);

        }
        else if (response.data.reply.code === 204) {
          message.error(response.data.reply.message);
          dispatch(togglePreloader(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

function isObjectEmpty(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}



function flattenData(data, type, ic_code, calc_exc_fields) {

  if (data == '')
    return;
  // data = JSON.parse(data);
  var new_data = [];
  data.forEach(function (each) {
    new_data.push(flatten(each));
  });
  console.log(new_data);
  new_data = JSON.stringify(new_data);
  const file_name = type + '_' + ic_code + '_' + calc_exc_fields
  JSONToCSVConvertor(new_data, file_name, true);
}

function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
  //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
  var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

  var CSV = '';
  //Set Report title in first row or line

  //CSV += ReportTitle + '\r\n\n';

  //This condition will generate the Label/Header
  if (ShowLabel) {
    var row = "";

    //This loop will extract the label from 1st index of on array
    for (var index in arrData[0]) {

      //Now convert each value to string and comma-seprated
      row += index + ',';
    }

    row = row.slice(0, -1);

    //append Label row with line break
    CSV += row + '\r\n';
  }

  //1st loop is to extract each row
  for (var i = 0; i < arrData.length; i++) {
    var row = "";

    //2nd loop will extract each column and convert it in string comma-seprated
    for (var index in arrData[i]) {
      row += '"' + arrData[i][index] + '",';
    }

    row.slice(0, row.length - 1);

    //add a line break after each row
    CSV += row + '\r\n';
  }

  if (CSV == '') {
    alert("Invalid data");
    return;
  }

  //Generate a file name
  var fileName = ReportTitle;
  //this will remove the blank-spaces from the title and replace it with an underscore
  // fileName += ReportTitle.replace(/ /g,"_");   

  //Initialize file format you want csv or xls
  var uri = 'data:text/csv;charset=utf-8,' + CSV;

  // Now the little tricky part.
  // you can use either>> window.open(uri);
  // but this will not work in some browsers
  // or you will not get the correct file extension    

  //this trick will generate a temp <a /> tag
  var link = document.createElement("a");
  link.href = uri;

  //set the visibility hidden so it will not effect on your web-layout
  link.style = "visibility:hidden";
  link.download = fileName + ".csv";

  //this part will append the anchor tag and remove it after automatic click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function flatten(data) {
  var result = {};
  function recurse(cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      for (var i = 0, l = cur.length; i < l; i++)
        recurse(cur[i], prop + "[" + i + "]");
      if (l == 0)
        result[prop] = [];
    } else {
      var isEmpty = true;
      for (var p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop + "." + p : p);
      }
      if (isEmpty && prop)
        result[prop] = {};
    }
  }
  recurse(data, "");
  return result;
}



// WEBPACK FOOTER //
// ./src/redux/actions/IC/ICActions.js